import React, { FormEvent, useContext, useEffect } from 'react';
import { Input } from '@headlessui/react';
import SessionContext from '../../contexts/SessionContext';
import { ArrowRight, Mail } from '../../components/ui/Icons';
import Wishlist from './Wishlist';
import { useRegisterBackInStockMutation } from '../../redux-modules/service';
import ProductContext from '../../contexts/ProductContext';

export default function BackInStock({ selectedVariant }: {
  selectedVariant: number;
}) {
  const [handleSubmit, { data: response, reset }] = useRegisterBackInStockMutation();

  const session = useContext(SessionContext);
  const { translates } = useContext(ProductContext);
  const { products } = translates;
  const { csrfTokenName, csrfTokenValue } = session;

  useEffect(() => {
    reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedVariant]);

  return (
    <>
      <h3 className="font-semibold text-base lg:text-lg mb-1">{Craft.t(products, 'Uitverkocht')}</h3>
      {response ? (
        <div className="flex gap-x-3 text-base lg:text-lg">
          {response.success ? (
            // eslint-disable-next-line react/no-danger
            <div className="text-white bg-green-500 p-4 rounded" dangerouslySetInnerHTML={{ __html: response.message }} />
          ) : (
            // eslint-disable-next-line react/no-danger
            <div className="text-white bg-accent p-4 rounded" dangerouslySetInnerHTML={{ __html: response.error }} />
          )}
          <Wishlist selectedVariant={selectedVariant} />
        </div>
      ) : (
        <>
          <span className="text-base leading-tight text-light-grey-3">{Craft.t(products, 'We sturen u een mailtje als dit artikel weer op voorraad is.')}</span>
          <form
            method="POST"
            className="mt-4"
            onSubmit={(event: FormEvent<HTMLFormElement>) => {
              const formData = new FormData(event.currentTarget);
              event.preventDefault();
              handleSubmit(formData);
            }}
          >
            <input type="hidden" name="variantId" value={selectedVariant} />
            {csrfTokenName && csrfTokenValue && (
              <input type="hidden" name={csrfTokenName} value={csrfTokenValue} />
            )}
            <div className="mb-4 relative input-icon">
              <Mail className="w-4.7 absolute top-1/2 -translate-y-1/2 left-6" />
              <Input
                type="email"
                name="email"
                placeholder={Craft.t(products, 'E-mail')}
                required
                className="w-full"
              />
            </div>
            <div className="flex gap-x-3">
              <button
                className="btn btn-secondary btn-lg w-full"
                type="submit"
              >
                {Craft.t(products, 'Geef me een seintje')}
                <ArrowRight />
              </button>
              <Wishlist selectedVariant={selectedVariant} />
            </div>
          </form>
        </>
      )}
    </>
  );
}
